import { Text, TouchableOpacity, View } from "react-native";
import Checkmark from "../svgs/Checkmark";

const SelectableEmploymentTile = ({
  title,
  selected,
  handleSwitch,
}: {
  title: string;
  selected: boolean;
  handleSwitch: () => void;
}) => {
  return (
    <TouchableOpacity
      onPress={handleSwitch}
      className={`rounded-lg h-30 border ${
        selected ? "border-primary-lighter border-2" : "border-sky-dark"
      } bg-white p-3 relative`}
    >
      <View>
        <View
          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
            selected ? "border-primary bg-primary" : "border-[#CDCFD0] bg-white"
          }`}
        >
          {selected && <Checkmark height={18} stroke="white" />}
        </View>
        <View className="mt-3">
          <Text className="text-regular-tight font-500 text-ink-dark mr-2" numberOfLines={1}>
            {title}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default SelectableEmploymentTile;
